<template>
  <div class="results-map-actions">
    <div class="results-map-actions-pane is-top">
      <button
        v-if="!noClose"
        :data-tooltip="$texts('closeMap')"
        class="button is-small"
        @click="$emit('close')"
      >
        <SpriteSymbol name="close" />
      </button>
    </div>
    <div class="results-map-actions-pane is-bottom">
      <button
        v-if="!noShowAll"
        :data-tooltip="$texts('showAllLocations')"
        class="button is-small"
        @click="$emit('showAll')"
      >
        <SpriteSymbol name="map-reframe" />
      </button>
      <button
        v-if="!noZoom"
        :data-tooltip="$texts('zoomIn')"
        class="button is-small belowTablet:hidden"
        @click="$emit('zoomIn')"
      >
        <span>+</span>
      </button>
      <button
        v-if="!noZoom"
        :data-tooltip="$texts('zoomOut')"
        class="button is-small belowTablet:hidden"
        @click="$emit('zoomOut')"
      >
        <span>-</span>
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    noClose?: boolean
    noShowAll?: boolean
    noZoom?: boolean
  }>(),
  {
    noClose: false,
    noShowAll: false,
    noZoom: false,
  },
)

const { $texts } = useEasyTexts()

defineEmits(['close', 'showAll', 'zoomIn', 'zoomOut'])
</script>

<style lang="postcss">
.results-map-actions-pane {
  @apply absolute right-0 flex flex-col;
  padding: 1rem;
  z-index: 150;
  .button {
    &:focus,
    &:hover {
      z-index: 102;
    }
    &:not(:first-child) {
      margin-top: -2px;
    }
    span {
      font-size: 1.5em;
    }
  }
  &.is-top {
    top: 0;
  }
  &.is-bottom {
    bottom: 0;
  }
}

.button[data-tooltip] {
  @apply relative;
  &:hover {
    &:before {
      @apply absolute block flex h-full items-center text-size-7 text-scheme-main;
      content: attr(data-tooltip);
      top: 50%;
      transform: translateY(-50%);
      right: 100%;
      background: rgba(0, 0, 0, 0.86);
      margin-right: 0.75rem;
      padding: 0 0.75rem;
      min-width: 6.25rem;
    }
    &:after {
      @apply absolute h-0 w-0 border-solid;
      content: '';
      right: 100%;
      top: 50%;
      margin-right: 4px;
      transform: translateY(-50%);
      border-width: 6px 0 6px 8px;
      border-color: transparent transparent transparent rgba(0, 0, 0, 0.86);
    }
  }
}
</style>
